import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NbMenuItem} from '@nebular/theme';

export const Menu: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'nb-home',
    home: true,
    link: 'home'
  },
  {
    title: 'Administracion',
    icon: 'nb-person',
    children: [
      {
        title: 'Usuarios',
        icon: "nb-chevron-right",
        link: 'usuarios'
      },
      {
        title: 'Empresas',
        icon: "nb-chevron-right",
        link: 'empresas'
      }
    ],
  },
  {
    title: 'Biodiversidad',
    expanded: true,
    icon: 'nb-loop-circled',
    children: [
      {
        title: 'Análisis GIS',
        icon: "nb-chevron-right",
        link: 'analisis'
      },
      {
        title: 'Estadísticas',
        icon: "nb-chevron-right",
        link: 'estadisticas'
      }
    ],
  },
  {
    title: 'AVC + HCS',
    expanded: true,
    icon: 'nb-drops',
    children: [
      {
        title: 'General',
        icon: "nb-chevron-right",
        link: 'ecosistemas'
      },
      {
        title: 'Analisis',
        icon: "nb-chevron-right",
        link: 'ecosistema-analisis'
      }
    ],
  },
  {
    title: 'Formularios',
    expanded: true,
    icon: 'nb-compose',
    children: [
      {
        title: 'Formularios',
        icon: "nb-chevron-right",
        link: 'crear-formularios'
      },
      {
        title: 'Respuestas',
        icon: "nb-chevron-right",
        link: 'encuestas'
      }
    ],
  },
  {
    title: 'Configuraciones',
    expanded: true,
    icon: 'nb-gear',
  }
];


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class MenuModule {
}
